// tslint:disable-next-line:ter-max-len
import { isValidPhoneNumber } from 'utils/isValidPhoneNumber/isValidPhoneNumber';

export const validatePhoneNumber = (label: string) => (value: string) =>
  value && isValidPhoneNumber(value) ? undefined : label;
